export const getLastError = (response) => {
  if (response) {
    const traceback = response().toJs();
    if (Array.isArray(traceback) && traceback.length > 0) {
      const size = traceback.length;
      return traceback[size - 1];
    }
  }
  return null;
};
